import { ContractVersionsPageIncidenceRuleFragment } from 'generated/resources/graphql'
import { runInAction } from 'mobx'

import { useEffect } from 'modules/core/hooks/useEffect'

import { useContractCues } from 'modules/contracts/lib/contractCuesContext'

const containsFieldInRules = (
  contractCues: { hasCues: boolean; incidenceRules: ContractVersionsPageIncidenceRuleFragment[] },
  fieldName: string
) => {
  if (contractCues.hasCues) {
    return contractCues.incidenceRules.some((rule) => rule.field === fieldName)
  }
  return false
}

export const useHasContractCue = () => {
  const contractCues = useContractCues()
  return (fieldName: string) => {
    if (contractCues.hasCues) {
      return containsFieldInRules(contractCues, fieldName)
    }
    return false
  }
}

export const useAddListToContractCuesContext = (
  formName: string,
  listOfFieldsToBeAdded: (string | undefined)[] = []
) => {
  const contractCues = useContractCues()
  useEffect(() => {
    runInAction(() => {
      if (contractCues.hasCues) {
        if (listOfFieldsToBeAdded && listOfFieldsToBeAdded.length > 0) {
          contractCues.listOfFields.set(formName, listOfFieldsToBeAdded)
        } else {
          if (contractCues.listOfFields.has(formName)) {
            contractCues.listOfFields.delete(formName)
          }
        }
      }
    })
  }, [
    formName,
    JSON.stringify(listOfFieldsToBeAdded),
    contractCues.hasCues,
    JSON.stringify(contractCues.listOfFields),
  ])
}
